import { useContext } from "react";

import { LanguageContext } from "../../../../../Context/Language.Context";
import { Link } from "react-router-dom";
// import Icon from "../../../IconElements/Icon";
// import Button from "../../../Buttons/Buttons";
import TheButton from "../../../UI/TheButton/TheButton";

// import SpecSheetLink from '../../../../Themes/Icons/clipboard-text.svg';
// import ManualLink from '../../../../Themes/Icons/book-open.svg';
// import InstallLink from '../../../../Themes/Icons/tool.svg';
import styles from './FeatureResources.module.css'
import TheIcon from "../../../UI/TheIcon/TheIcon";
import BodyContainer from "../../../UI/BodyContainer/BodyContainer";
import { PageText } from "../../../../../components/Text/Text";

const FeatureResources = ({ product }) => {

    const { language } = useContext(LanguageContext);
    const isEnglish = language === "EN";


    const resources = [
        {
            resourceTitle: isEnglish ? "Owner's Manual" : "Le manuel du propriétaire",
            // resourceUrl: isEnglish ? product.ownerManualLinkEN : product.ownerManualLinkFR,
            resourceUrl: product.ownerManualLink
        },
        {
            resourceTitle: isEnglish ? "Installation Guide" : "Guide d'installation",
            resourceUrl: product.installGuideLink
            // resourceUrl: isEnglish ? product.installGuideLinkEN : product.installGuideLinkFR,
        },
        ...(product.sections || []).map(section => ({
            resourceTitle: isEnglish ? section.resourceTitleEN : section.resourceTitleFR,
            resourceUrl: isEnglish ? section.resourceUrlEN : section.resourceUrlFR,
        }))
    ].filter(item => item.resourceUrl && item.resourceTitle);

    return (

        (product.sections.length !== 0) && (
            <div className={styles.resourceLinksWrapper}>
                {resources.map((resource, idx) => (
                    <a key={idx} href={resource.resourceUrl} className={styles.resourceLink} target="_blank" rel="noopener noreferrer">
                        <TheButton
                            animated="true"
                            icon
                            buttonIcon
                            iconName="externalLink"
                            iconText={resource.resourceTitle}
                            styleName="lightButtonIcon"
                        />
                    </a>
                ))}
            </div>
        )
    );
};

export default FeatureResources;